import { createSelector } from 'reselect'
import {
  AccountRevisionListModel,
  AccountRevisionListResponse,
} from 'src/models/accountRevision.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectBudgetRevisionListResponsesFromState = (
  state: RootState,
): Record<string, AccountRevisionListResponse> =>
  state.data.budgetRevisions.listResponses
export const selectBudgetRevisionListModelsFromState = createSelector(
  [selectBudgetRevisionListResponsesFromState],
  (budgetRevisionListResponses) =>
    Object.values(budgetRevisionListResponses).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new AccountRevisionListModel(curr),
      }),
      {} as Record<string, AccountRevisionListModel>,
    ),
)
